var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Flex, Heading, Text } from '@chakra-ui/react';
export const SectionHeading = (_a) => {
    var { description, mb = '10', title } = _a, rest = __rest(_a, ["description", "mb", "title"]);
    return (_jsxs(Flex, Object.assign({ direction: 'column', mb: mb }, rest, { children: [_jsx(Heading, Object.assign({ as: 'h2', color: 'darkBrandBlue.100', fontSize: '24px' }, { children: title })), description && (_jsx(Text, Object.assign({ color: 'darkBrandBlue.100', mt: '2', opacity: '0.7' }, { children: description }))), _jsx(Divider, { borderColor: 'grey.80', mt: '6' })] })));
};
